import { useEffect, useState } from "react";

// Assuming you have these components in the same directory or update paths accordingly
import { RegisterAgreement } from "./RegisterAgreement";
import { RegisterFormContainer } from "./RegisterFormContainer";
import RegisterResult from "./RegisterResult";

const Register = ({ url, category, domain }) => {
  const [mode, setMode] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    let params = new URLSearchParams(url.search);
    setMode(params.get("mode") || "agreement");
    setName(params.get("name"));
    setPassword(params.get("password"));
    setPhoneNumber(params.get("phoneNumber"));
  }, []);

  const renderComponentBasedOnMode = () => {
    switch (mode) {
      case "agreement":
        return (
          <RegisterAgreement mode={mode} category={category} domain={domain} />
        );
      case "apply":
      case "edit":
        return (
          <RegisterFormContainer
            url={url}
            mode={mode}
            category={category}
            name={name}
            phoneNumber={phoneNumber}
            password={password}
            domain={domain}
          />
        );
      case "result":
        return (
          <RegisterResult
            mode={mode}
            category={category}
            name={name}
            phoneNumber={phoneNumber}
            password={password}
            domain={domain}
          />
        );
      default:
        return <div>Invalid mode provided.</div>;
    }
  };

  return <div>{renderComponentBasedOnMode()}</div>;
};

export default Register;
